export default {
    beepedAt: {
        label: 'onlineSchedule.date',
        type: 'general',
        field: 'beepedAt',
        align: 'left',
        customWidth: 130,
        render: true,
        fixed: false,
    },
    branch: {
        label: 'delimit.report.table.store',
        field: 'branch',
        type: 'general',
        align: 'left',
        customWidth: 230,
        fixed: false,
        render: true,
    },
    lm: {
        label: 'lm_label',
        field: 'lm',
        type: 'general',
        align: 'left',
        customWidth: 120,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    desc: {
        label: 'reports.description',
        field: 'desc',
        type: 'general',
        align: 'left',
        customWidth: 300,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    section: {
        label: 'delimit.report.table.section',
        field: 'section',
        type: 'general',
        align: 'left',
        customWidth: 180,
        fixed: false,
        render: true,
    },
    systemPrice: {
        label: 'price.audit.systemPrice',
        field: 'systemPrice',
        type: 'general',
        align: 'left',
        customWidth: 200,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    ticketPrice: {
        label: 'price.audit.ticketPrice',
        field: 'ticketPrice',
        type: 'general',
        align: 'left',
        customWidth: 200,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    statusPrice: {
        label: 'price.audit.statusPrice',
        field: 'statusPrice',
        type: 'labelColor',
        align: 'left',
        customWidth: 140,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    beepedBy: {
        label: 'price.audit.beepedBy',
        field: 'beepedBy',
        type: 'general',
        align: 'left',
        customWidth: 280,
        fixed: false,
        render: true,
        disableOrder: true,
    }
};
